import { Helmet } from 'react-helmet-async';
import TrainingForm from "../components/forms/training/createTraining"

export default function TrainingService() {

  return (
    <>
      <Helmet>
        <title> Solicitud de Recomendaciones y Capacitaciones | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <header  style={{ maxWidth: '100%',paddingTop:'10px',display:'flex', justifyContent:'center'}} >
        <img
          src='https://procompetencia.gob.do/wp-content/themes/betheme-child/img/logo.png'
          alt="Logo Procompetencia" 
          style={{ maxWidth: '170px', height: 'auto'}} 
          />
      </header>
      <TrainingForm valuesToEdit={{}} onClose={() => { }} />
    </>
  );
}